import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const useUrlBasedStep = ({ location }) => {
  const { t } = useTranslation();

  const stepText = useMemo(() => {
    if (location.pathname.includes("/preview")) {
      return t("Create campaign");
    } else if (location.pathname.includes("/overview")) {
      return t("Overview");
    } else if (location.pathname.includes("/budget-check")) {
      return t("Budget");
    } else if (location.pathname.includes("/checkout")) {
      return t("Checkout");
    }
    return t("Campaign assistant");
  }, [location.pathname, t]);

  const { stepName } = useMemo(() => {
    if (location.pathname.includes("/preview")) {
      return { stepName: "preview" };
    } else if (location.pathname.includes("/overview")) {
      return { stepName: "overview" };
    } else if (location.pathname.includes("/budget-check")) {
      return { stepName: "budget-check" };
    } else if (location.pathname.includes("/checkout")) {
      return { stepName: "checkout" };
    }
    return { stepName: "chatbot" };
  }, [location.pathname]);

  return { stepText, stepName };
};

export { useUrlBasedStep };
